import { isFunction } from "lodash";
import Back from "../Components/svg/back.svg";
import Button from "./Button";

const ActionButtons = ({
  onNext,
  onBack,
  buttonText = "Suivant",
  disabled = false,
  buttonWidth = 366,
  icon,
  className,
  loading,
  title = "",
}) => {
  return (
    <div className="lmf__actions">
      {isFunction(onBack) && (
        <span className="lmf__actions--icon" onClick={onBack}>
          <img src={Back} alt="Back" />
        </span>
      )}
      <div className="lmf__actions--button">
        {isFunction(onNext || buttonText) && (
          <Button
            type={disabled ? "white" : "primary"}
            width={buttonWidth}
            alignment="center"
            disabled={disabled}
            onClick={onNext}
            className={className}
            loading={loading}
            size="large"
            title={title}
          >
            <span>{buttonText}</span>
            {icon}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ActionButtons;
